module.exports = __webpack_public_path__ + "img/image_gallery2.7a3cd447.jpg";